// extracted by mini-css-extract-plugin
export default {"chip-no-hover":"service-providers_chip-no-hover__lHyYE"};